// ========================================
// SCENARII PREDEFINITE DE ACCIDENT
// Coordonate: x,y relative la centru (0,0)
// Rotație: 0=nord(sus), 90=est(dreapta), 180=sud(jos), 270=vest(stânga)
// ========================================

export const ACCIDENT_SCENARIOS = {
  
  // ===== 1. TAMPONARE DIN SPATE =====
  'tamponare_spate': {
    id: 'tamponare_spate',
    name: 'Tamponare din spate',
    description: 'B lovește A din spate pe același sens',
    tipDrum: 'drum_drept',
    vehiculA: { x: 20, y: -25, rotation: 0 },
    vehiculB: { x: 20, y: 45, rotation: 0 },
    impactPoint: { x: 20, y: 10 },
    keywords: ['spate', 'tamponare', 'din urmă', 'nu a frânat', 'lovit în spate', 'oprit', 'semafor', 'frână']
  },

  // ===== 2. IMPACT FRONTAL =====
  'frontal_sens_opus': {
    id: 'frontal_sens_opus',
    name: 'Impact frontal',
    description: 'Coliziune frontală între A și B din sensuri opuse',
    tipDrum: 'drum_drept',
    vehiculA: { x: 10, y: 35, rotation: 0 },
    vehiculB: { x: -10, y: -35, rotation: 180 },
    impactPoint: { x: 0, y: 0 },
    keywords: ['frontal', 'sens opus', 'față', 'cap la cap', 'față în față', 'intrat pe contrasens']
  },

  // ===== 3. VIRAJ STÂNGA + SENS OPUS =====
  'viraj_stanga_sens_opus': {
    id: 'viraj_stanga_sens_opus',
    name: 'Viraj stânga',
    description: 'A virează stânga în intersecție, B vine din sens opus',
    tipDrum: 'intersectie',
    vehiculA: { x: 5, y: 15, rotation: -35 },
    vehiculB: { x: -20, y: -25, rotation: 180 },
    impactPoint: { x: -5, y: -8 },
    keywords: ['viraj stânga', 'stânga', 'sens opus', 'virare', 'lovit în dreapta', 'viram la stânga']
  },

  // ===== 4. VIRAJ DREAPTA =====
  'viraj_dreapta': {
    id: 'viraj_dreapta',
    name: 'Viraj dreapta',
    description: 'A virează dreapta, B vine din spate sau lateral',
    tipDrum: 'intersectie',
    vehiculA: { x: 25, y: 10, rotation: 35 },
    vehiculB: { x: 20, y: 55, rotation: 0 },
    impactPoint: { x: 22, y: 32 },
    keywords: ['viraj dreapta', 'dreapta', 'virat dreapta', 'virare dreapta']
  },

  // ===== 5. PRIORITATE DREAPTA (B vine din dreapta) =====
  'prioritate_dreapta': {
    id: 'prioritate_dreapta',
    name: 'Neacordare prioritate (A din dreapta)',
    description: 'B nu acordă prioritate lui A care vine din dreapta',
    tipDrum: 'intersectie',
	vehiculA: { x: 55, y: -15, rotation: 270 },
    vehiculB: { x: 15, y: 30, rotation: 0 },
    impactPoint: { x: 18, y: 0 },
    keywords: ['prioritate', 'din dreapta', 'dreapta mea', 'neacordare prioritate', 'nu am văzut']
  },

  // ===== 6. B VINE DIN STÂNGA =====
  'lovit_din_stanga': {
    id: 'lovit_din_stanga',
    name: 'B vine din stânga',
    description: 'B nu acordă prioritate, vine din stânga lui A',
    tipDrum: 'intersectie',
    vehiculA: { x: 15, y: 40, rotation: 0 },
    vehiculB: { x: -20, y: 15, rotation: 90 },
    impactPoint: { x: 5, y: 25 },
    keywords: ['din stânga', 'stânga mea', 'a venit din stânga', 'nu a acordat prioritate', 'lovit în stânga']
  },

// ===== 7. NERESPECTARE SEMAFOR =====
'semafor': {
    id: 'semafor',
    name: 'Nerespectare semafor',
    description: 'Unul dintre vehicule trece pe roșu',
    tipDrum: 'intersectie',
    vehiculA: { x: 20, y: 35, rotation: 0 },
    vehiculB: { x: -45, y: 15, rotation: 90 },   // ← y: -15 devine y: 15
    impactPoint: { x: 0, y: 5 },                   // ← ajustat și impactul
    keywords: ['semafor', 'roșu', 'verde', 'culoare', 'stop', 'trecut pe roșu']
},

  // ===== 8. SCHIMBARE BANDĂ =====
  'schimbare_banda': {
    id: 'schimbare_banda',
    name: 'Schimbare bandă',
    description: 'Coliziune la schimbarea benzii de circulație',
    tipDrum: 'drum_drept',
    vehiculA: { x: -20, y: 5, rotation: 0 },
    vehiculB: { x: 22, y: 25, rotation: -12 },
    impactPoint: { x: 0, y: 12 },
    keywords: ['bandă', 'schimbat banda', 'a intrat pe banda', 'schimbare bandă', 'benzi']
  },

// ===== 9a. DEPĂȘIRE - TĂIERE =====
  'depasire_taiere': {
    id: 'depasire_taiere',
    name: 'Depășire - tăiere',
    description: 'B depășește și se bagă înapoi prea devreme, lovind fața lui A',
    tipDrum: 'drum_drept',
    vehiculA: { x: 20, y: 10, rotation: 0 },
    vehiculB: { x: -5, y: -20, rotation: 15 },
    impactPoint: { x: 8, y: -5 },
    keywords: ['depășire', 'tăiere', 'se bagă', 'bagat în față', 'tăiat', 'depășit și s-a băgat']
  },

  // ===== 9b. DEPĂȘIRE - AGĂȚARE LATERALĂ =====
  'depasire_agatare': {
    id: 'depasire_agatare',
    name: 'Depășire - agățare laterală',
    description: 'B iese în depășire și agață lateral vehiculul A',
    tipDrum: 'drum_drept',
    vehiculA: { x: 20, y: 5, rotation: 0 },
    vehiculB: { x: -10, y: 0, rotation: -10 },
    impactPoint: { x: 5, y: 2 },
    keywords: ['agățat', 'lateral', 'iese în depășire', 'a ieșit', 'depășire laterală']
  },

  // ===== 9c. DEPĂȘIRE - A VIREAZĂ STÂNGA =====
  'depasire_acelerare': {
    id: 'depasire_acelerare',
    name: 'Depășire - A virează stânga',
    description: 'A virează stânga fără să observe pe B care depășea',
    tipDrum: 'drum_drept',
    vehiculA: { x: 10, y: 5, rotation: -20 },
    vehiculB: { x: -20, y: -10, rotation: 0 },
    impactPoint: { x: -5, y: -2 },
    keywords: ['virat stânga', 'nu a văzut', 'depășea', 'am virat', 'schimbat direcția']
  },

  // ===== 10. MERS ÎNAPOI =====
  'mers_inapoi': {
    id: 'mers_inapoi',
    name: 'Mers înapoi',
    description: 'Unul dintre vehicule mergea cu spatele',
    tipDrum: 'parcare',
    vehiculA: { x: -35, y: 0, rotation: 180 },
    vehiculB: { x: 25, y: 15, rotation: 270 },
    impactPoint: { x: -5, y: 8 },
    keywords: ['spatele', 'înapoi', 'marșarier', 'cu spatele', 'mers înapoi', 'marche arriere']
  },

  // ===== 11. IEȘIRE DIN PARCARE =====
  'iesire_parcare': {
    id: 'iesire_parcare',
    name: 'Ieșire din parcare',
    description: 'B iese din loc de parcare și lovește A',
    tipDrum: 'parcare',
	vehiculA: { x: 15, y: 25, rotation: 270 },
    vehiculB: { x: -35, y: -15, rotation: 135 },
    impactPoint: { x: -10, y: 10 },
    keywords: ['parcare', 'ieșire', 'ieșit', 'loc de parcare', 'ieșea din parcare', 'pleca din parcare']
  },

  // ===== 12. INTRARE ÎN GIRATORIU =====
  'giratoriu_intrare': {
    id: 'giratoriu_intrare',
    name: 'Intrare în sens giratoriu',
    description: 'Coliziune la intrarea în giratoriu - neacordare prioritate',
    tipDrum: 'sens_giratoriu',
	vehiculA: { x: 20, y: 15, rotation: 30 },
    vehiculB: { x: 0, y: 65, rotation: 0 },
    impactPoint: { x: 5, y: 38 },
    keywords: ['giratoriu', 'sens giratoriu', 'intrat în giratoriu', 'rotondă', 'intrare giratoriu']
  },

  // ===== 13. DESCHIDERE PORTIERĂ =====
  'portiera': {
    id: 'portiera',
    name: 'Deschidere portieră',
    description: 'B deschide portiera și lovește A care trece',
    tipDrum: 'parcare',
	vehiculA: { x: -15, y: 18, rotation: 0 },
    vehiculB: { x: -45, y: 0, rotation: 0 },
    impactPoint: { x: -30, y: 15 },
    keywords: ['portieră', 'ușă', 'deschis', 'deschidere', 'deschis ușa']
  },
  
  // ===== 14. IEȘIRE DIN STRADĂ SECUNDARĂ / CURTE =====
  'iesire_laterala': {
    id: 'iesire_laterala',
    name: 'Ieșire din stradă secundară',
    description: 'B iese din stradă laterală/curte fără să acorde prioritate lui A',
    tipDrum: 'intersectie',
    vehiculA: { x: 20, y: 40, rotation: 0 },
    vehiculB: { x: -40, y: 10, rotation: 90 },
    impactPoint: { x: 5, y: 15 },
    keywords: ['ieșire', 'stradă laterală', 'curte', 'proprietate', 'garaj', 'alee', 'a ieșit din', 'nu a acordat']
  },

  // ===== 15. ÎNTOARCERE (U-TURN) =====
  'intoarcere': {
    id: 'intoarcere',
    name: 'Întoarcere (U-turn)',
    description: 'A face întoarcere, B venea din spate și nu poate evita',
    tipDrum: 'drum_drept',
    vehiculA: { x: 5, y: -5, rotation: -90 },
    vehiculB: { x: 20, y: 35, rotation: 0 },
    impactPoint: { x: 12, y: 15 },
    keywords: ['întoarcere', 'u-turn', 'întors', 'a făcut întoarcere', 'viraj 180', 'a întors']
  },

  // ===== 16. LOVIRE VEHICUL STAȚIONAR =====
  'lovire_stationare': {
    id: 'lovire_stationare',
    name: 'Lovire vehicul staționar',
    description: 'B lovește vehiculul A care era parcat/oprit',
    tipDrum: 'drum_drept',
    vehiculA: { x: 20, y: -20, rotation: 0 },
    vehiculB: { x: 18, y: 40, rotation: -5 },
    impactPoint: { x: 19, y: 10 },
    keywords: ['staționar', 'parcat', 'oprit', 'stătea', 'nu se mișca', 'lovit mașina parcată', 'mașină oprită']
  },

  // ===== 17. ACCIDENT ÎN CURBĂ =====
  'curba': {
    id: 'curba',
    name: 'Accident în curbă',
    description: 'Unul dintre vehicule pierde controlul în curbă și intră pe contrasens',
    tipDrum: 'curba',
    vehiculA: { x: 0, y: 25, rotation: 0 },
    vehiculB: { x: -5, y: -20, rotation: 170 },
    impactPoint: { x: -2, y: 2 },
    keywords: ['curbă', 'viraj', 'alunecat', 'derapaj', 'contrasens', 'pierdut controlul', 'curbă la dreapta', 'curbă la stânga']
  }
};

// ===== FUNCȚIE DETECTARE SCENARIU DIN TEXT =====
export function detectScenario(description) {
  if (!description) return null;
  
  // Normalizăm textul (lowercase, fără diacritice)
  const text = description.toLowerCase()
    .replace(/[șş]/g, 's')
    .replace(/[țţ]/g, 't')
    .replace(/[ăâ]/g, 'a')
    .replace(/[îï]/g, 'i');
  
  let bestMatch = null;
  let bestScore = 0;
  
  for (const scenario of Object.values(ACCIDENT_SCENARIOS)) {
    let score = 0;
    
    for (const keyword of scenario.keywords) {
      const kw = keyword.toLowerCase()
        .replace(/[șş]/g, 's')
        .replace(/[țţ]/g, 't')
        .replace(/[ăâ]/g, 'a')
        .replace(/[îï]/g, 'i');
      
      if (text.includes(kw)) {
        // Cuvinte mai lungi = scor mai mare
        score += kw.length;
      }
    }
    
    if (score > bestScore) {
      bestScore = score;
      bestMatch = scenario;
    }
  }
  
  return bestMatch;
}

// ===== LISTĂ PENTRU DROPDOWN =====
export const SCENARIO_LIST = Object.values(ACCIDENT_SCENARIOS).map(s => ({
  id: s.id,
  name: s.name,
  description: s.description
}));

export default ACCIDENT_SCENARIOS;